import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { RotateCcw } from "lucide-react";

export const PaymentCancel = () => (
  <div className="h-screen w-screen sadara-bg grain flex items-center justify-center px-4" data-testid="payment-cancel-page">
    <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="glass rounded-3xl max-w-md w-full p-8 text-center">
      <RotateCcw className="w-10 h-10 text-gold mx-auto" />
      <h1 className="font-display text-2xl mt-4">Payment cancelled</h1>
      <p className="text-sm text-muted-foreground mt-2">No worries — nothing was charged. Your itinerary is saved and Isack is ready whenever you are.</p>
      <Link to="/" className="inline-block mt-6 rounded-full bg-gold px-7 py-3 text-sm font-semibold text-background hover:bg-gold-soft transition-colors" data-testid="back-home-btn">
        Return to Isack
      </Link>
    </motion.div>
  </div>
);
